var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32,
  _t33;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { getFormattedDate, isValidText, createFakeComment } from './Helper/functions.js';
import css from './style.pcss';
import Translations from './Translations.js';
import { getOffsetRect, getHeaderHeight } from './Helper/Dimensions.js';
import ApiRepository from './Repository/ApiRepository.js';
import Pager from './Components/Pager.js';
import OrderByBlock from './Components/OrderByBlock.js';
import SetNicknameBlock from './Components/SetNicknameBlock.js';
import Thumb from './Components/Thumb.js';
var RTLComments = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLComments, _LitElement);
  function RTLComments() {
    var _this;
    _classCallCheck(this, RTLComments);
    _this = _callSuper(this, RTLComments);
    var location = window.location.origin;
    if (_this.attributes.debug && _this.attributes.debug.nodeValue === 'true') {
      location = 'http://localhost:8080';
    }
    _this.repo = new ApiRepository(location);
    _this.order = localStorage.getItem('commentOrder') || 'desc';
    if (_this.attributes.order && _this.attributes.order.nodeValue === 'asc') {
      _this.order = 'asc';
    }
    _this.loadingResponseBox = 0;
    _this.loading = 0;
    _this.currentPage = 1;
    _this.entriesPerPage = 10;
    _this.comments = null;
    _this.newCommentText = '';
    _this.invalidComment = false;
    _this.invalidReport = false;
    _this.answerAtCommentId = 0;
    _this.extendedAnswerComments = [];
    _this.userIsBlacklisted = false;
    _this.gigya = window.gigya;
    _this.messagePostedSuccesfully = false;
    _this.reportPostedSuccesfully = false;
    _this.nicknameSet = false;
    _this.uid = '';
    _this.nickname = '';
    _this.maxCommentLength = 1000;
    _this.mainText = '';
    _this.respText = '';
    _this.ignoredUids = [];
    _this.acceptedNetiquette = false;
    _this.checkUserLoggedIn();
    if (window.rtlsites) {
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
    }
    return _this;
  }
  _createClass(RTLComments, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      _get(_getPrototypeOf(RTLComments.prototype), "connectedCallback", this).call(this);
      var context = this.attributes.context.nodeValue; // en kennt properties hei nach net direkt um this?
      // find get params
      var getParams = [];
      location.search.substr(1).split('&').forEach(function (item) {
        getParams[item.split('=')[0]] = item.split('=')[1];
      });
      this.getParams = getParams;
      this.fetchComments(context, function () {
        var cid = parseInt(_this2.getParams.cid);
        if (!cid) return false;
        var position = -1;
        for (var i = 0; i < _this2.comments.length; i++) {
          var comment = _this2.comments[i];
          if (comment.id === cid) {
            position = i;
            break;
          }
          for (var j = 0; j < comment.answerComments.length; j++) {
            if (comment.answerComments[j].id === cid) {
              position = i;
              _this2.extendedAnswerComments.push(comment.id);
              break;
            }
          }
        }
        if (position >= 0) {
          var page = Math.ceil((position + 1) / _this2.entriesPerPage);
          _this2.currentPage = page;
          _this2.requestUpdate().then(function () {
            var elem = _this2.shadowRoot.getElementById('comment-' + cid);
            setTimeout(function () {
              // euni den timeout fresst en den scrollto net, wtf
              window.scrollTo(0, getOffsetRect(elem).top - getHeaderHeight());
            }, 200);
          });
        }
      });
    }
  }, {
    key: "checkUserLoggedIn",
    value: function checkUserLoggedIn() {
      var _this3 = this;
      if (!window.gigya) {
        setTimeout(function () {
          return _this3.checkUserLoggedIn();
        }, 200);
      } else {
        this.gigya = window.gigya;
        this.gigya.accounts.getJWT({
          callback: function callback(r) {
            return _this3.getJWTResponse(r);
          }
        });
      }
    }
  }, {
    key: "fetchIgnoredUids",
    value: function fetchIgnoredUids() {
      var _this4 = this;
      this.repo.getIgnoredUids(this.jwt).then(function (resp) {
        _this4.ignoredUids = resp.ignoredUids;
      });
    }
  }, {
    key: "fetchAcceptedNetiquette",
    value: function fetchAcceptedNetiquette() {
      var _this5 = this;
      this.loadingResponseBox += 1;
      this.repo.getAcceptedNetiquette(this.jwt).then(function (resp) {
        _this5.acceptedNetiquette = resp.accepted_netiquette;
        _this5.loadingResponseBox -= 1;
      });
    }
  }, {
    key: "checkUserHasNickname",
    value: function checkUserHasNickname(jwt) {
      var _this6 = this;
      this.loadingResponseBox += 1;
      this.repo.getNicknameByJwt(jwt).then(function (resp) {
        _this6.nicknameSet = resp.ok;
        _this6.uid = resp.uid;
        _this6.nickname = resp.nickname;
        _this6.checkUserBlacklisted();
        _this6.fetchIgnoredUids();
        _this6.fetchAcceptedNetiquette();
        _this6.loadingResponseBox -= 1;
      });
    }
  }, {
    key: "checkUserBlacklisted",
    value: function checkUserBlacklisted() {
      var _this7 = this;
      this.loadingResponseBox += 1;
      this.repo.getBlacklistedByUid(this.uid).then(function (resp) {
        _this7.userIsBlacklisted = resp.blacklisted;
        _this7.loadingResponseBox -= 1;
      });
    }
  }, {
    key: "getJWTResponse",
    value: function getJWTResponse(response) {
      if (parseInt(response.errorCode) === 0 && response.id_token) {
        this.jwt = response.id_token;
        this.loggedIn = true;
        this.checkUserHasNickname(response.id_token);
      } else {
        this.loggedIn = false;

        // Quick Hack for iOS
        var urlParams = new URLSearchParams(window.location.search);
        var showLogin = urlParams.get('showlogin');
        if (showLogin === 'true') {
          window.gigya.accounts.showScreenSet({
            screenSet: 'Default-RegistrationLogin-test',
            startScreen: 'gigya-login-screen',
            lang: this.language,
            enabledProviders: 'facebook,googleplus',
            onAfterSubmit: function onAfterSubmit(resp) {
              if (resp.response.errorCode == 0) {
                location.reload();
              }
            }
            // redirectURL: this.currentUrl+"/#/"
          });
        }
      }
    }
  }, {
    key: "fetchComments",
    value: function fetchComments(context) {
      var _this8 = this;
      var doneCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.showLoadingIndicator();
      // fetch(this.location+"/comments?status=1&order="+this.order+"&count="+this.entriesPerPage+"&page="+this.currentPage+"&context="+encodeURI(context))
      this.repo.getCommentsByContext(context, this.order).then(function (comments) {
        if (!_this8.comments) {
          _this8.comments = [];
        }
        var newComments = [].concat(_toConsumableArray(_this8.comments), _toConsumableArray(comments));
        _this8.comments = newComments;
        doneCallback();
        _this8.hideLoadingIndicator();
      }).catch(function (e) {
        _this8.hideLoadingIndicator();
      });
    }
  }, {
    key: "fetchCommentById",
    value: function fetchCommentById(id) {
      var _this9 = this;
      var doneCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.showLoadingIndicator();
      this.repo.getCommentById(id, this.order).then(function (comments) {
        var added = false;
        comments.forEach(function (comment) {
          for (var i = 0; i < _this9.comments.length; i++) {
            if (_this9.comments[i].id === comment.id) {
              _this9.comments[i] = comment;
              added = true;
            }
          }
        });
        if (!added) {
          comments.forEach(function (comment) {
            _this9.comments.push(comment);
          });
        }
        doneCallback();
        _this9.hideLoadingIndicator();
      }).catch(function (e) {
        // console.log('ERROR', e);
        _this9.hideLoadingIndicator();
      });
    }
  }, {
    key: "submitNewComment",
    value: function submitNewComment() {
      var _this10 = this;
      var parentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var text = this.shadowRoot.getElementById('new-comment-text').value;
      if (parentId !== 0) {
        text = this.shadowRoot.getElementById('answer-comment-text').value;
      }
      if (!isValidText(text)) {
        this.invalidComment = true;
        return false;
      } else {
        this.invalidComment = false;
      }
      this.showLoadingIndicator();
      this.repo.addComment(this.jwt, text, this.context, parentId).then(function (resp) {
        if (resp.ok) {
          _this10.messagePostedSuccesfully = true;
          var fakeComment = createFakeComment(_this10.context, parentId, _this10.nickname, text);
          if (parentId === 0) {
            _this10.comments.push(fakeComment);
          } else {
            for (var i = 0; i < _this10.comments.length; i++) {
              if (_this10.comments[i].id === parentId) {
                var newComment = _this10.comments[i];
                newComment.answerComments.push(fakeComment);
                _this10.comments[i] = newComment;
                break;
              }
            }
          }
        }
        _this10.hideLoadingIndicator();
      }).catch(function (e) {
        _this10.hideLoadingIndicator();
      });
    }
  }, {
    key: "updateCommentThumbsById",
    value: function updateCommentThumbsById(comment, value) {
      var previousVote = comment.voters[this.uid];
      comment.voters[this.uid] = value;
      // console.log("----");
      // console.log("previousVote", previousVote)
      // console.log("currentVote", value, comment)
      // console.log("----");

      // klick ouni vidrun undefenied 0
      if (previousVote === undefined || previousVote === 0) {
        if (value === 1) {
          comment.likes.up++;
        }
        if (value === -1) {
          comment.likes.down++;
        }
        return;
      }

      // klick deen aaneren button
      if (previousVote !== value) {
        if (value === 1) {
          comment.likes.up++;
          comment.likes.down--;
        }
        if (value === -1) {
          comment.likes.up--;
          comment.likes.down++;
        }
        if (value === 0) {
          // console.log("KLICKT EWECH!")

          if (previousVote === 1) {
            comment.likes.up--;
          }
          if (previousVote === -1) {
            comment.likes.down--;
          }
          return;
        }
        return;
      }

      // console.log("UPDATE DONE", comment, value);
    }
  }, {
    key: "setThumbs",
    value: function setThumbs(comment, value) {
      var _this11 = this;
      var isThumbSet = comment.voters[this.uid] === value;

      // if (!this.loggedIn || !this.nicknameSet) {
      if (!this.loggedIn) {
        window.scrollTo(0, getOffsetRect(this.shadowRoot.getElementById('main-comment-block')).top - getHeaderHeight());
        return false;
      }
      var realValue = isThumbSet ? 0 : value;
      this.showLoadingIndicator();
      this.repo.setThumbs(this.jwt, comment.id, comment.contextId, realValue).then(function (resp) {
        if (resp.ok) {
          var id = comment.parentId !== 0 ? comment.parentId : comment.id;
          // this.fetchCommentById(id);
          _this11.updateCommentThumbsById(comment, realValue);
          //hei updaten
        }
        _this11.hideLoadingIndicator();
      }).catch(function (e) {
        _this11.hideLoadingIndicator();
      });
    }
  }, {
    key: "showLoadingIndicator",
    value: function showLoadingIndicator() {
      this.loading++;
    }
  }, {
    key: "hideLoadingIndicator",
    value: function hideLoadingIndicator() {
      this.loading--;
    }
  }, {
    key: "submitNicknameChange",
    value: function submitNicknameChange() {
      var _this12 = this;
      var nickname = this.shadowRoot.getElementById('new-nickname-input').value;
      this.showLoadingIndicator();
      this.repo.changeNickname(this.jwt, nickname).then(function (r) {
        return r.json();
      }).then(function (resp) {
        if (resp.ok) {
          _this12.checkUserLoggedIn();
        } else {
          if (resp.message === 'Invalid Nickname') {
            _this12.shadowRoot.getElementById('nickname-error-text').innerHTML = Translations.invalid_nickname[_this12.language];
          }
          if (resp.message === 'Nickname already taken') {
            _this12.shadowRoot.getElementById('nickname-error-text').innerHTML = Translations.nickname_taken[_this12.language];
          }
        }
        _this12.hideLoadingIndicator();
      }).catch(function (e) {
        _this12.hideLoadingIndicator();
      });
    }
  }, {
    key: "renderSetNicknameBlock",
    value: function renderSetNicknameBlock() {
      var _this13 = this;
      if (!this.loggedIn) return null;
      return SetNicknameBlock(this.language, this.loading, function () {
        return _this13.submitNicknameChange();
      });
    }
  }, {
    key: "showLoginScreenset",
    value: function showLoginScreenset() {
      if (window.rtlsites.config.isApp) {
        if (window.rtlsites.config.isIosApp && parseInt(window.rtlsites.config.appCode) === 63004) {
          location.href = window.rtlsites.config.currentApp + '://safari/' + window.location.href + '&showlogin=true#comments';
          return;
        }
        location.href = window.rtlsites.config.currentApp + '://login';
        return;
      }
      var lang = this.language;
      // if (lang === "lu") {
      //     lang = "fr-inf";
      // }

      this.gigya.accounts.showScreenSet({
        screenSet: 'Default-RegistrationLogin-test',
        startScreen: 'gigya-login-screen',
        lang: lang,
        enabledProviders: 'facebook,googleplus',
        onAfterSubmit: function onAfterSubmit(resp) {
          if (resp.response.errorCode == 0) {
            location.reload();
          }
        }
        // redirectURL: this.currentUrl+"/#/"
      });
    }
  }, {
    key: "submitReportComment",
    value: function submitReportComment(commentId) {
      var _this14 = this;
      var text = this.shadowRoot.getElementById('report-comment-text').value;
      if (!isValidText(text)) {
        this.invalidReport = true;
      } else {
        this.invalidReport = false;
        this.showLoadingIndicator();
        this.repo.reportComment(this.jwt, text, commentId).then(function (resp) {
          _this14.reportPostedSuccesfully = true;
          var responseText = '';
          if (resp.ok) {
            responseText = Translations.thanks_reported_message[_this14.language];
          } else {
            responseText = Translations.unknown_error[_this14.language];
          }
          _this14.reportPostedMessage = responseText;
          _this14.hideLoadingIndicator();
        }).catch(function (e) {
          _this14.hideLoadingIndicator();
        });
      }
    }
  }, {
    key: "renderReportBlock",
    value: function renderReportBlock(commentId) {
      var _this15 = this;
      if (!this.loggedIn || !this.nicknameSet) return null;
      if (this.userIsBlacklisted) {
        var msg = Translations.you_are_blacklisted_report[this.language];
        return html(_t || (_t = _`<div class="new-comments__container" id="report-block">
                            <div class="comments-report">
                                ${0}
                            </div>
                        </div>`), unsafeHTML(msg));
      }
      if (this.reportPostedSuccesfully) {
        return html(_t2 || (_t2 = _`<div class="new-comments__container" id="report-block">
                            <div class="comments-tkanks-message">
                                ${0}
                            </div>
                        </div>
            `), this.reportPostedMessage);
      }
      var submitButton = html(_t3 || (_t3 = _`<div
                                    class="new-comments__button"
                                    @click=${0}
                                >
                                    <div class="new-comments__post-comment button-default-co">${0}</div>
                                </div>`), function (e) {
        _this15.submitReportComment(commentId);
      }, Translations.report[this.language]);
      if (this.loading > 0) {
        submitButton = html(_t4 || (_t4 = _`<div class="new-comments__button new-comments__loading">
                                        <div class="spinner"></div>
                                </div>`));
      }
      return html(_t5 || (_t5 = _`
            <div class="new-comments__container" id="report-block">
                <div class="comments-report">
                ${0}
                </div>
                <textarea class="new-comments__text" title="comment" id="report-comment-text" placeholder=""></textarea>
                ${0}
            </div>
        `), Translations.why_report_message[this.language], submitButton);
    }
  }, {
    key: "renderNotLoggedInBlock",
    value: function renderNotLoggedInBlock() {
      var _this16 = this;
      if (!window.gigya) return html(_t6 || (_t6 = _`
            <a href="/login-help" class="button-not-logged-link">
            <div
                    id="main-comment-block"
                    class="button-not-logged"
            >
                <div class="button-default-co">Login</div>
                ${0}
            </div>
            </a>
        `), Translations.not_logged_in[this.language]);
      return html(_t7 || (_t7 = _`
            <div
                id="main-comment-block"
                class="button-not-logged"
                @click=${0}
            >
                <div class="button-default-co">Login</div>
                ${0}
            </div>
            `), function () {
        return _this16.showLoginScreenset();
      }, Translations.not_logged_in[this.language]);
    }
  }, {
    key: "setText",
    value: function setText(value, isReply) {
      var tooLong = value.length > this.maxCommentLength;
      var text = tooLong ? value.substring(0, this.maxCommentLength) : value;
      if (isReply) {
        this.shadowRoot.getElementById('answer-comment-text').value = text;
        this.respText = text;
      } else {
        this.shadowRoot.getElementById('new-comment-text').value = text;
        this.mainText = text;
      }
    }
  }, {
    key: "renderAnswerBlock",
    value: function renderAnswerBlock() {
      var _this17 = this;
      var parentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.readonly) return null;
      if (this.loadingResponseBox !== 0) {
        return html(_t8 || (_t8 = _`<div></div>`));
      }
      if (!this.loggedIn && this.answerAtCommentId === 0) {
        return this.renderNotLoggedInBlock();
      }
      if (!this.nicknameSet) return this.renderSetNicknameBlock();
      if (!this.acceptedNetiquette) return this.renderNetiquetteBlock();
      if (this.messagePostedSuccesfully) {
        return html(_t9 || (_t9 = _`
                <div id="main-comment-block" class="comments-tkanks-message">
                    ${0}
                </div>
                `), Translations.thanks_message[this.language]);
      }
      var errorMessage = null;
      if (this.invalidComment) errorMessage = html(_t10 || (_t10 = _`<div class="comments-invalid">${0}</div>`), Translations.invalid_comment[this.language]);
      var submitButton = html(_t11 || (_t11 = _`<div
                                    class="new-comments__button"
                                    @click=${0}
                                >
                                    <div class="new-comments__post-comment button-default-co">${0}</div>
                                </div>`), function (e) {
        _this17.submitNewComment(parentId);
      }, Translations.post_comment[this.language]);
      if (this.loading > 0) {
        submitButton = html(_t12 || (_t12 = _`<div class="new-comments__button new-comments__loading">
                                        <div class="spinner"></div>
                                </div>`));
      }
      var blacklistedMessage = '';
      var textAreaId = 'new-comment-text';
      var textValue = this.mainText;
      if (parentId !== 0) {
        textAreaId = 'answer-comment-text';
        textValue = this.respText;
      }
      var textArea = html(_t13 || (_t13 = _`<textarea
            .value="${0}"
            @input=${0}
            class="new-comments__text"
            title="comment"
            id=${0}
            placeholder="${0}">
            ${0}
        </textarea>`), textValue, function (e) {
        return _this17.setText(e.target.value, parentId !== 0);
      }, textAreaId, Translations.new_comment_placeholder[this.language], textValue);
      var maxCommentLengthElem = html(_t14 || (_t14 = _`<div class="new-comments__nickname">${0}/${0}</div>`), textValue.length, this.maxCommentLength);
      if (this.userIsBlacklisted) {
        blacklistedMessage = Translations.you_are_blacklisted[this.language];
        maxCommentLengthElem = null;
        textArea = null;
        submitButton = null;
      }
      return html(_t15 || (_t15 = _`
            <div id="main-comment-block" class="new-comments__container">
                ${0}
                <h2 class="new-comments__title">${0}</h2>
                <div class="new-comments__nickname">${0} <b> &laquo; ${0} &raquo;</b></div>
                <div class="new-comments__nickname">${0}</div>
                ${0}
                ${0}
                ${0}
            </div>
            `), errorMessage, Translations.new_comment[this.language], Translations.your_nickname_is[this.language], this.nickname, unsafeHTML(blacklistedMessage), textArea, maxCommentLengthElem, submitButton);
    }
  }, {
    key: "renderStyleBlock",
    value: function renderStyleBlock() {
      return html(_t16 || (_t16 = _`
            <style>${0}</style>
        `), css);
    }
  }, {
    key: "renderPagination",
    value: function renderPagination(displayShowAllButton) {
      var _this18 = this;
      return Pager(this.currentPage, this.comments.length, this.entriesPerPage, this.language, displayShowAllButton, function (page) {
        return _this18.currentPage = page;
      }, function (entries) {
        return _this18.entriesPerPage = entries;
      }, this.scrollToTop.bind(this));
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, getOffsetRect(this.shadowRoot.getElementById('top-of-comments')).top - getHeaderHeight());
    }
  }, {
    key: "renderOrderByBlock",
    value: function renderOrderByBlock() {
      var _this19 = this;
      return OrderByBlock(this.order, this.language, function () {
        _this19.order = _this19.order === 'asc' ? 'desc' : 'asc';
        localStorage.setItem('commentOrder', _this19.order);
        _this19.comments = [];
        _this19.currentPage = 1;
        _this19.fetchComments(_this19.context);
      });
    }
  }, {
    key: "ignoreUser",
    value: function ignoreUser(uid) {
      var _this20 = this;
      this.repo.ignoreUser(this.jwt, uid).then(function (resp) {
        _this20.ignoredUids = resp.ignoredUids;
      });
    }
  }, {
    key: "removeIgnoredUser",
    value: function removeIgnoredUser(uid) {
      var _this21 = this;
      this.repo.removeIgnoredUser(this.jwt, uid).then(function (resp) {
        _this21.ignoredUids = resp.ignoredUids;
      });
    }
  }, {
    key: "setReportCommentId",
    value: function setReportCommentId(id) {
      if (!this.loggedIn) {
        this.showLoginScreenset();
        return;
      }
      if (!this.nicknameSet) {
        window.scrollTo(0, getOffsetRect(this.shadowRoot.getElementById('main-comment-block')).top - getHeaderHeight());
        return;
      }
      this.reportPostedSuccesfully = false;
      this.reportCommentId = id;
    }
  }, {
    key: "setAnswerAtCommentId",
    value: function setAnswerAtCommentId(id) {
      if (!this.loggedIn) {
        this.showLoginScreenset();
        return;
      }
      if (!this.nicknameSet) {
        window.scrollTo(0, getOffsetRect(this.shadowRoot.getElementById('main-comment-block')).top - getHeaderHeight());
        return;
      }
      this.messagePostedSuccesfully = false;
      this.answerAtCommentId = id;
    }
  }, {
    key: "renderStars",
    value: function renderStars(nStars) {
      if (nStars === -1) {
        return html(_t17 || (_t17 = _`<div class="comments-username__newuser">(${0})</div>`), Translations.new_user[this.language]);
      }
      var resp = [];
      for (var i = 0; i < nStars; i++) {
        resp.push(html(_t18 || (_t18 = _`<div class="comments-username__nstars"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19 18.5" style="enable-background:new 0 0 19 18.5;" xml:space="preserve"> <style type="text/css"> .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#f9d700;} </style> <g id="Calque_2"> </g> <g id="Calque_3"> <g transform="translate(0,-952.36218)"> <path class="st1" d="M9.5,952.6c-0.2,0-0.3,0.1-0.4,0.3l-2,6.2l-6.6,0c-0.2,0-0.4,0.2-0.4,0.4c0,0.1,0.1,0.3,0.2,0.3l5.3,3.8 l-2,6.2c-0.1,0.2,0,0.5,0.3,0.5c0.1,0,0.3,0,0.4-0.1l5.3-3.9l5.3,3.9c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.1,0.1-0.3,0.1-0.4l-2-6.2 l5.3-3.8c0.2-0.1,0.2-0.4,0.1-0.6c-0.1-0.1-0.2-0.2-0.3-0.2l-6.6,0l-2-6.2C9.8,952.7,9.7,952.6,9.5,952.6z"/></g></g></svg></div>`)));
      }
      return resp;
    }
  }, {
    key: "renderCommentBlock",
    value: function renderCommentBlock(comment) {
      var _this22 = this;
      var subcomment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      comment.answerComments.sort(function (a, b) {
        return new Date(a.dateCreated).getTime() - new Date(b.dateCreated).getTime();
      });
      var subcommentClass = '';
      if (subcomment) subcommentClass = ' comments-container--sub';
      if (this.ignoredUids.includes(comment.userId)) {
        return html(_t19 || (_t19 = _`<div id="comment-${0}" class="comments-container${0} comments-container--ignore-user">
                            <div class="comments-container__header">
                                <div class="comments-username-date__container">
                                    <div class="comments-username">
                                        ${0}
                                        <div class="comments-username__stars"> ${0} </div>
                                    </div>
                                    <div class="comments-date">
                                        <span>-</span>  ${0}
                                    </div>
                                </div>
                                <div class="comments-text__hidden"><i>${0}</i></div>
                                <div class="comments-actions__showcomment" @click=${0}>
                                    <div class="comments-actions__showcomment-img"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19 18.5" style="enable-background:new 0 0 19 18.5;" xml:space="preserve"> <style type="text/css"> .st0{fill:#565656;}</style> <g id="Calque_2"> </g> <g id="Calque_3"> <g> <path class="st0" d="M11.3,7.1c-0.5-0.4-1.1-0.6-1.8-0.6c-0.4,0-0.9,0.1-1.3,0.3c0,0,0.1,0,0.1,0C9,6.8,9.5,7.3,9.5,8 S9,9.1,8.3,9.2S7.2,8.6,7.2,8c0-0.1,0-0.2,0-0.3c-1,1.3-0.7,3.1,0.5,4.1c1.3,1,3.1,0.7,4.1-0.5C12.8,9.9,12.6,8.1,11.3,7.1z"/> <path class="st0" d="M0.1,9.4c10.1,12.7,18.9,0,18.9,0C8.7-3.3,0.1,9.4,0.1,9.4z M9.5,13.4c-2.2,0-4.1-1.8-4.1-4s1.8-4,4.1-4 c2.2,0,4.1,1.8,4.1,4S11.8,13.4,9.5,13.4z"/></g></g></svg></div>
                                    ${0}
                                </div>
                            </div>
                        </div>`), comment.id, subcommentClass, comment.userName || comment.name, this.renderStars(comment.userStars), getFormattedDate(comment.dateCreated), Translations.hidden_comment[this.language], function () {
          return _this22.removeIgnoredUser(comment.userId);
        }, Translations.stop_ignoring[this.language]);
      }

      // const upStyle = comment.voters[this.uid] === 1 ? 'color:blue' : '';
      // const downStyle = comment.voters[this.uid] === -1 ? 'color:blue' : '';
      // let commentText = comment.text.replace(/(?:\r\n|\r|\n)/g, '<br />');
      var commentText = [];
      comment.text.split(/(?:\r\n|\r|\n)/g).map(function (w) {
        return commentText.push(html(_t20 || (_t20 = _`${0}<br/>`), w));
      });
      var answerComments = [];
      var answerTitle = null;
      var answerBlock = null;
      var reportBlock = null;
      var answerButton = null;
      var maxAnswerComments = 3;
      var reportButton = null;
      var ignoreButton = null;
      if (!comment.fakeComment && window.gigya) {
        reportButton = html(_t21 || (_t21 = _`<div class="comments-actions__report" @click=${0}>
                                    <div class="comments-actions__report-img"><svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14"><path d="m8.4,9.8l.3-3.8v-1h-1.3v1l.2,3.8h.8Zm-1,.8h1.4v1.4h-1.4v-1.4Z"/><path d="m8,0L0,14h16L8,0Zm0,2l6.3,11H1.7L8,2Z"/></svg></div>
                                    ${0}
                                </div>`), function () {
          return _this22.setReportCommentId(comment.id);
        }, Translations.report[this.language]);
        if (this.loggedIn) {}
        ignoreButton = html(_t22 || (_t22 = _`<div class="comments-actions__hide" @click=${0}>
                                        <div class="comments-actions__hide-img"><svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14.4"><path d="m16,7.2c-1.7-2.9-4.7-4.8-8-4.8h0c-1.1,0-2.3.2-3.3.7L1.5,0l-.7.7,2.9,2.9c-1.5.8-2.8,2.1-3.7,3.6,1.7,2.9,4.7,4.8,8,4.8,1.1,0,2.3-.2,3.3-.7l3.1,3.1.8-.8-2.9-2.9c1.5-.7,2.8-2,3.7-3.5Zm-14.7,0c.7-1,1.6-1.9,2.6-2.5-.4.7-.7,1.6-.7,2.5s.3,1.8.7,2.5c-1-.6-1.9-1.5-2.6-2.5Zm6.7,3.7c-2.1,0-3.7-1.7-3.7-3.7,0-.8.3-1.6.7-2.2l1,1c-.2.4-.3.8-.3,1.2,0,1.3,1,2.3,2.3,2.3.4,0,.8-.1,1.2-.3l1,1c-.6.4-1.4.7-2.2.7h0Zm3-1.5l-1-1c.2-.4.3-.8.3-1.2,0-1.3-1-2.3-2.3-2.3h0c-.4,0-.8.1-1.2.3l-1-1c.6-.5,1.4-.7,2.2-.7h0c2.1,0,3.7,1.7,3.7,3.7,0,.8-.2,1.6-.7,2.2Zm1.1-4.7c1,.6,1.9,1.5,2.6,2.5-.7,1-1.6,1.9-2.6,2.5.5-.7.7-1.6.7-2.5s-.3-1.8-.7-2.5Z"/></svg></div>
                                        ${0}
                                    </div>`), function () {
          return _this22.ignoreUser(comment.userId);
        }, Translations.ignore[this.language]);
      }
      if (!subcomment && !this.readonly && !comment.fakeComment && window.gigya) {
        answerButton = html(_t23 || (_t23 = _`<div class="comments-actions__reply" @click=${0}>
                                    <div class="comments-actions__reply-img"><svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 16"><path d="m8.4,12.2c2.5,0,4.6-2.1,4.6-4.6V0h-.8v7.6c0,2.1-1.7,3.8-3.8,3.8H1.3l2.8-3.8h-1L0,11.8l3.1,4.2h1l-2.8-3.8h7.1Z"/></svg></div>
                                    ${0}
                                </div>
            `), function () {
          return _this22.setAnswerAtCommentId(comment.id);
        }, Translations.answer[this.language]);
      }
      if (this.answerAtCommentId === comment.id) answerBlock = this.renderAnswerBlock(comment.id);
      if (this.reportCommentId === comment.id) reportBlock = this.renderReportBlock(comment.id);
      var showMoreButton = null;
      if (!subcomment && !this.extendedAnswerComments.includes(comment.id) && comment.answerComments.length > maxAnswerComments) {
        // et muss een [...this.extendedAnswerComments, comment.id] benotzen am plaatz push() well daat den ganzen array nei setzt
        // am plaatz en ze mutaten, waat lit dann net erkennt.
        showMoreButton = html(_t24 || (_t24 = _`<div class="button-container__show button-default-co"
                                    @click=${0}
                                  >
                                    <div class="button-container__show-img">
                                        <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.6 25.6"><polygon fill="currentColor" points="11.6 0 11.6 11.6 0 11.6 0 14 11.6 14 11.6 25.6 14 25.6 14 14 25.6 14 25.6 11.6 14 11.6 14 0 11.6 0"/></svg>
                                    </div>

                                    ${0}
                                  </div>`), function () {
          return _this22.extendedAnswerComments = [].concat(_toConsumableArray(_this22.extendedAnswerComments), [comment.id]);
        }, Translations.show_more_answers[this.language]);
      }
      if (this.extendedAnswerComments.includes(comment.id)) {
        comment.answerComments.forEach(function (ac) {
          return answerComments.push(_this22.renderCommentBlock(ac, true));
        });
      } else {
        comment.answerComments.slice(0, maxAnswerComments).forEach(function (ac) {
          return answerComments.push(_this22.renderCommentBlock(ac, true));
        });
      }
      var thumbsBlock = null;
      if (!this.noThumbs) {
        var pointerStyle = '';
        if (!window.gigya) pointerStyle = 'cursor:default';
        thumbsBlock = html(_t25 || (_t25 = _`
                <div class="comments-likes__wrapper" style="${0}">
                    <div class="comments-like__container" @click=${0}>
                        ${0}
                        ${0}
                    </div>
                    <div class="comments-dislike__container" @click=${0}>
                        ${0}
                        ${0}
                    </div>
                </div>`), pointerStyle, function () {
          return _this22.setThumbs(comment, 1);
        }, Thumb(true, comment.voters[this.uid] === 1), comment.likes.up, function () {
          return _this22.setThumbs(comment, -1);
        }, Thumb(false, comment.voters[this.uid] === -1), comment.likes.down);
      }
      return html(_t26 || (_t26 = _`<div id="comment-${0}" class="comments-container${0}">
                        <div class="comments-container__header">
                            <div class="comments-username-date__container">
                                <div class="comments-username">
                                    <div class="comments-username__text">${0}</div>
                                    <div class="comments-username__stars"> ${0} </div>
                                </div>
                                <div class="comments-date">
                                    <span>-</span>  ${0}
                                </div>
                            </div>

                            ${0}

                            ${0}

                            <div class="comments-text">${0}</div>

                            <div class="comments-actions">
                                ${0}
                                ${0}
                                ${0}
                            </div>
                        </div>

                        <div class="comments-container__reply">
                            ${0}
                            ${0}
                            ${0}
                            ${0}
                            ${0}
                        </div>
                    </div>`), comment.id, subcommentClass, comment.userName || comment.name, this.renderStars(comment.userStars), getFormattedDate(comment.dateCreated), thumbsBlock, comment.fakeComment && html(_t27 || (_t27 = _`<div style='color:red'>${0}</div>`), Translations.need_validation_text[this.language]), commentText, ignoreButton, reportButton, answerButton, reportBlock, answerBlock, answerTitle, answerComments, showMoreButton);
    }
  }, {
    key: "acceptNetiquette",
    value: function acceptNetiquette() {
      var _this23 = this;
      var userCheckbox = this.shadowRoot.getElementById('accept_username').checked;
      var netiquetteCheckbox = this.shadowRoot.getElementById('accept_netiquette').checked;
      if (!userCheckbox) {
        this.shadowRoot.getElementById('accept_username_container').style.color = 'red';
      } else {
        this.shadowRoot.getElementById('accept_username_container').style.color = null;
      }
      if (!netiquetteCheckbox) {
        this.shadowRoot.getElementById('accept_netiquette_container').style.color = 'red';
      } else {
        this.shadowRoot.getElementById('accept_netiquette_container').style.color = null;
      }
      if (!userCheckbox || !netiquetteCheckbox) return false;
      this.repo.setAcceptedNetiquette(this.jwt).then(function (resp) {
        _this23.fetchAcceptedNetiquette();
      });
    }
  }, {
    key: "renderNetiquetteBlock",
    value: function renderNetiquetteBlock() {
      var _this24 = this;
      return html(_t28 || (_t28 = _`<div id="main-comment-block" class="netiquette__container">
                        <div class="netiquette__intro-text">${0}</div>
                        <div class="netiquette__accept-username" id="accept_username_container"><input type="checkbox" id="accept_username"> <label for="accept_username">${0}</label></div>
                        <div class="netiquette__accept-netiquette" id="accept_netiquette_container"><input type="checkbox" id="accept_netiquette"> <label for="accept_netiquette">${0}</label></div>
                        <button class="netiquette__button" @click=${0}>${0}</button>
                </div>`), unsafeHTML(Translations.nettiquette_intro_text[this.language]), Translations.confirm_user_name[this.language].replace('{username}', this.nickname), unsafeHTML(Translations.confirm_netiquette[this.language]), function () {
        return _this24.acceptNetiquette();
      }, Translations.post_comment[this.language]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this25 = this;
      var content = null;
      if (this.comments === null) {
        content = html(_t29 || (_t29 = _`
                <div class="comments-loading-comment">
                    ${0}
                </div>
            `), Translations.loading[this.language]);
      } else if (this.comments.length === 0) {
        content = html(_t30 || (_t30 = _`
                <div class="comments-no-comments">
                    ${0}
                </div>
                ${0}
            `), Translations.no_comments[this.language], this.renderAnswerBlock());
      } else {
        var displayComments = this.comments.slice((this.currentPage - 1) * this.entriesPerPage, (this.currentPage - 1) * this.entriesPerPage + this.entriesPerPage);
        content = html(_t31 || (_t31 = _`
                <div class="comments-wrapper">
                    ${0}
                    <div class="button-order">
                        ${0}
                    </div>
                    ${0}
                    ${0}
                    ${0}
                </div>
            `), this.renderPagination(), this.renderOrderByBlock(), displayComments.map(function (comment) {
          return _this25.renderCommentBlock(comment);
        }), this.renderPagination(true), this.renderAnswerBlock());
      }
      var newCommentButton = null;
      if (!this.readonly && window.gigya && this.comments && this.comments.length > 0) {
        newCommentButton = html(_t32 || (_t32 = _`
            <div class="button-default-co"
                id="top-of-comments"
                @click=${0}
            >
                ${0}
            </div>`), function () {
          return window.scrollTo(0, getOffsetRect(_this25.shadowRoot.getElementById('main-comment-block')).top - getHeaderHeight());
        }, Translations.write_new_comment[this.language]);
      }
      return html(_t33 || (_t33 = _`
            ${0}
            <div class="comments__title-button">
                <h1 class="comments__title">${0}</h1>
                ${0}
            </div>
            ${0}
        `), this.renderStyleBlock(), this.title || Translations.default_title[this.language], newCommentButton, content);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        context: {
          type: String
        },
        loading: {
          type: Number
        },
        loadingResponseBox: {
          type: Number
        },
        language: {
          type: String
        },
        comments: {
          type: Array
        },
        loggedIn: {
          type: Boolean
        },
        debug: {
          type: Boolean
        },
        messagePostedSuccesfully: {
          type: Boolean
        },
        reportPostedSuccesfully: {
          type: Boolean
        },
        reportPostedMessage: {
          type: String
        },
        nicknameSet: {
          type: Boolean
        },
        invalidComment: {
          type: Boolean
        },
        invalidReport: {
          type: Boolean
        },
        userIsBlacklisted: {
          type: Boolean
        },
        acceptedNetiquette: {
          type: Boolean
        },
        order: {
          type: String
        },
        answerAtCommentId: {
          type: Number
        },
        reportCommentId: {
          type: Number
        },
        entriesPerPage: {
          type: Number
        },
        currentPage: {
          type: Number
        },
        extendedAnswerComments: {
          type: Array
        },
        readonly: {
          type: Boolean
        },
        noThumbs: {
          type: Boolean
        },
        ignoredUids: {
          type: Array
        },
        mainText: {
          type: String
        },
        respText: {
          type: String
        }
      };
    }
  }]);
  return RTLComments;
}(LitElement);
export { RTLComments as default };
if (window.rtlsites && window.rtlsites.config.isSportApp !== true) {
  window.customElements.define('rtl-comments', RTLComments);
}